// import gsap from "gsap";

// import { ScrollTrigger } from "gsap/ScrollTrigger";

import "swiper/css/bundle";

// import LocomotiveScroll from "locomotive-scroll";

import "../../style.css";

import "./modules/preloader";

import "./modules/nav";

import "./modules/zero-fees-animation";

import "./modules/protected-animation";

import "./modules/trade-on-the-go";

import "./modules/carousel";

// gsap.registerPlugin(ScrollTrigger);

// temp check canvas height

// document.querySelector('.canvas-wrapper').style

// document.querySelectorAll(".canvas-wrapper").style.width = window.innerHeight * 1.77777778 + "px";

// document.querySelectorAll(".canvas-wrapper").forEach((wrapper) => {
//   wrapper.style.width = window.innerHeight * 1.77777778 + "px";
// });

// const locoScroll = new LocomotiveScroll({
//   el: document.querySelector("[data-scroll-container]"),
//   smooth: true,
// });

// locoScroll.on("scroll", ScrollTrigger.update);

// ScrollTrigger.scrollerProxy("[data-scroll-container]", {
//   scrollTop(value) {
//     return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
//   }, // we don't have to define a scrollLeft because we're only scrolling vertically.
//   getBoundingClientRect() {
//     return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
//   },
//   // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
//   pinType: document.querySelector("[data-scroll-container]").style.transform ? "transform" : "fixed",
// });

// webp detect

// function support_format_webp() {
//   var elem = document.createElement("canvas");

//   if (!!(elem.getContext && elem.getContext("2d"))) {
//     // was able or not to get WebP representation
//     return elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
//   } else {
//     // very old browser like IE 8, canvas not supported
//     return false;
//   }
// }

// window.webp = support_format_webp();

// canvas resizer

const canvasResize = (canvas) => {
  if (canvas.offsetHeight < window.innerHeight) {
    let percentage = (window.innerHeight / (document.body.offsetWidth * 0.5625)) * 100;
    canvas.style.width = percentage + "%";
  }
};

document.querySelectorAll(".canvas-wrapper").forEach((canvas) => {
  canvasResize(canvas);
});

window.addEventListener("resize", () => {
  document.querySelectorAll(".canvas-wrapper").forEach((canvas) => {
    canvasResize(canvas);
  });
});
